module.exports = __webpack_public_path__ + "static/paper-yellow-064ab26210673b995ed517011017dd9c.webp";